import axios from 'lib/axios'
import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'

export const usePackageStore = create(
  devtools(
    subscribeWithSelector((set, get) => ({
      package: null,
      loading: false,
      everLoaded: false,
      error: null,

      loadPackage: async (packageId) => {
        if (get().loading) return
        set({ loading: true, error: null }, false, 'loadPackage/pending')
        try {
          const { data } = await axios.get(`/packages/${packageId}/data`)
          set({ package: data }, false, 'loadPackage/fulfilled')
        } catch (error) {
          set({ error }, false, 'loadPackage/rejected')
        } finally {
          set({ loading: false, everLoaded: true }, false, 'loadPackage/done')
        }
      },

      updateRequirementsApproved: (requirementIds, approved) =>
        set((s) => {
          if (!s.package) return {}
          const ids = new Set([].concat(requirementIds))
          return {
            package: {
              ...s.package,
              visible_package_requirements: s.package.visible_package_requirements.map((r) =>
                ids.has(r.id) ? { ...r, approved } : r
              ),
            },
          }
        }, false, 'updateRequirementsApproved'),
    })),
    { name: 'packageStore', enabled: process.env.NODE_ENV === 'development' }
  )
)

export const selectPackage = (s) => s.package
export const selectPackageLoading = (s) => s.loading
export const selectPackageEverLoaded = (s) => s.everLoaded
export const selectPackageError = (s) => s.error

document.addEventListener('requirement:lock-changed', ({ detail: { requirementId, approved } }) => {
  usePackageStore.getState().updateRequirementsApproved(requirementId, approved)
})

document.addEventListener('requirement:lock-all-changed', ({ detail: { requirementIds, approved } }) => {
  usePackageStore.getState().updateRequirementsApproved(requirementIds, approved)
})

export const selectRequirementTitle = (requirementId) => (s) =>
  s.package?.visible_package_requirements?.find((r) => r.id == requirementId)?.title ?? null

export const selectDocumentOfRequirement = (requirementId, documentId) => (s) =>
  s.package?.visible_package_requirements
    ?.find((r) => r.id == requirementId)
    ?.package_documents?.find((d) => d.id == documentId)

export const selectAllDocumentsOfRequirement = (requirementId) => (s) =>
  s.package?.visible_package_requirements?.find((r) => r.id == requirementId)?.package_documents

export const selectRequirementTitlesMap = (s) =>
  Object.fromEntries((s.package?.visible_package_requirements ?? []).map((r) => [r.id, r.title]))

export const selectDocumentLabel = (documentId) => (s) =>
  s.package?.visible_package_requirements?.flatMap((r) => r.package_documents ?? [])?.find((d) => d.id == documentId)
    ?.label ?? null
